import { Link } from 'react-router-dom';
import { cn } from '../../../../../../lib/utils';
import { secondaryText } from '../../../../../../styling/stylingHelper';
import type { QtyFlagCustomerRequest } from '../../../../../../services/admin/adminService';
import { requestAgeDays } from './qtyFlagGrouping';
import type { TFn } from '../../types';

const CHIP = 'px-1.5 py-0.5 rounded text-[10px] font-medium underline-offset-2 hover:underline';

// Where this flag's customer question stands. Approving does not clear a flag, so it stays open here until
// the recheck closes it.
export function QtyFlagRequestStatus({ requests, t }: { requests: QtyFlagCustomerRequest[]; t: TFn }) {
  if (requests.length === 0) return null;
  // One question reads fine without its restaurant; several on one row can't be told apart without it.
  const withRestaurant = (text: string, request: QtyFlagCustomerRequest) => (requests.length > 1 ? `${text} · ${request.restaurantName}` : text);
  const chip = (request: QtyFlagCustomerRequest) => {
    if (request.status === 'pending') {
      const days = requestAgeDays(request.createdAt);
      const age = days === null ? '' : days === 0 ? t('adminTesting.review.requestAgeToday') : t('adminTesting.review.requestAgeDays', { days });
      const text = [t('customerRequests.pending'), request.restaurantName, age, request.dismissedByAll ? t('adminTesting.review.requestDismissed') : ''].filter(Boolean).join(' · ');
      return { text, cls: cn(CHIP, 'bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-200') };
    }
    if (request.status === 'awaiting_review') return { text: withRestaurant(t('adminTesting.review.requestAwaitingReview'), request), cls: cn(CHIP, 'bg-indigo-100 dark:bg-indigo-900/40 text-indigo-700 dark:text-indigo-300') };
    if (request.status === 'completed') return { text: withRestaurant(t('adminTesting.review.requestApproved'), request), cls: cn(CHIP, 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200') };
    return { text: withRestaurant(t('customerRequests.requestState', { status: t(`customerRequests.${request.status}`) }), request), cls: cn(secondaryText, 'text-[10px] underline') };
  };
  return (
    <span className="mt-0.5 flex flex-wrap gap-1">
      {requests.map((request) => {
        const { text, cls } = chip(request);
        return <Link key={request.id} className={cls} to={`/admin/communication/customer-requests?requestId=${encodeURIComponent(request.id)}`} onClick={(event) => event.stopPropagation()}>{text}</Link>;
      })}
    </span>
  );
}
